module.exports = __webpack_public_path__ + "static/media/Phone_Alerts_And_Rings.a10bc4f4.mp3";